module.exports = __webpack_public_path__ + "static/media/granizado_cacahuate.f4f46d34.png";